import { render, staticRenderFns } from "./FinalizacaoDesassociarDespViagem.vue?vue&type=template&id=df63b3d8"
import script from "./FinalizacaoDesassociarDespViagem.vue?vue&type=script&lang=js"
export * from "./FinalizacaoDesassociarDespViagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports